export default __webpack_public_path__ + "static/media/danji_cg_04.ed385a1c.jpg";